window.dataLayer = window.dataLayer || [];
export default function push(event) {
    try {
        window.dataLayer.push(event);
    }
    catch (e) {
        console.error("Error: GTM container not loaded");
    }
}
